export const BASE_STEP_IDS = ["INTRO", "BRANDING", "SUCCESS"];

export const GAME_TYPE_FORM_CONFIG = {
  connections: {
    label: "Connections",
    steps: ["INTRO", "BRANDING", "CONTENT", "COLORS", "SUCCESS"],
    gameDataShape: "connections",
    allowedAccess: ["connections", "all"],
    visibleBasicFields: ["name", "type", "adminNotes", "activeFrom", "activeUntil"],
  },
  memory: {
    label: "Memory",
    steps: ["INTRO", "BRANDING", "MEMORY", "SUCCESS"],
    gameDataShape: "memory",
    allowedAccess: ["memory", "all"],
    visibleBasicFields: ["name", "type", "adminNotes", "activeFrom", "activeUntil"],
  },
};

export const STEP_DEFINITIONS = {
  INTRO: { id: 1, name: "INTRO" },
  BRANDING: { id: 2, name: "BRANDING" },
  CONTENT: { id: 3, name: "CONTENT" },
  COLORS: { id: 4, name: "COLORS" },
  MEMORY: { id: 5, name: "MEMORY" },
  SUCCESS: { id: 6, name: "SUCCESS" },
};

export const normalizeGameAccess = (gameAccess) => {
  if (!Array.isArray(gameAccess) || gameAccess.length === 0) {
    return ["all"];
  }
  const normalized = gameAccess
    .map((entry) => String(entry || "").trim().toLowerCase())
    .filter(Boolean);
  if (normalized.includes("all")) {
    return ["all"];
  }
  return [...new Set(normalized)];
};

export const getAllowedGameTypes = (gameAccess) => {
  const normalizedAccess = normalizeGameAccess(gameAccess);
  const allTypes = Object.keys(GAME_TYPE_FORM_CONFIG);
  if (normalizedAccess.includes("all")) {
    return allTypes;
  }
  return allTypes.filter((type) => {
    const cfg = GAME_TYPE_FORM_CONFIG[type];
    return cfg.allowedAccess.some((allowed) => normalizedAccess.includes(allowed));
  });
};
